import { forwardRefWithAs } from '@reckon-web/utils';

import { DialogBase } from './DialogBase';

// NOTE: ideally this wouldn't be necessary. It could be resolved with a
// significant refactor, where the `ContentDialog` accepts `header/body/footer |
// children` and layout is enforced when `body` is present in props.

type BlankDialogProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

/** @deprecated The BlankDialog component has been deprecated and will be removed in future versions. Use the SideDrawer package instead.  */
export const BlankDialog = forwardRefWithAs<'div', BlankDialogProps>(
  (props, ref) => {
    return <DialogBase ref={ref} {...props} />;
  }
);
